<div class="percentage-bar-container">
  <div class="progress-bar">
    <div class="progress" [style.width.%]="percentage"></div>
  </div>
  <span class="value">{{percentage | number:'1.2-2'}}%</span>
</div> 